<template>
  <div>
    <design-list></design-list>
  </div>
</template>

<script>

export default {
}
</script>

<style>

</style>
